import React from 'react';
import { format } from 'date-fns';
import ArrayHelper from 'foundation/array-helper';
import { getPlayerTeeTime } from 'general/js/helpers';
import { SpriteSvg } from 'project/sprite-svg';

const LeaderboardTeeTimesGroup = ({ scoringLeaderboard, player, isPlayOff }) => {
    if (ArrayHelper.isEmpty(player.rounds)) return null;

    if (isPlayOff ||
        (player.hole && player.hole !== 'F')
    ) {
        return null;
    }

    const tenStart = player.startTee.toString() === '10';
    const teeTime = getPlayerTeeTime(
        scoringLeaderboard.currentRound,
        scoringLeaderboard.currentRoundStatus,
        player.rounds
    );
    const formatedTeeTime = teeTime && format(teeTime.replace('Z', ''), 'h:mm a');

    if (!formatedTeeTime) return null;

    return (
        <div className="leaderboard__tee-times-group">
            <div className="leaderboard__tee-times-group-icon-wrapper">
                <SpriteSvg iconName="clock" width="14" height="14" />
            </div>
            <div className="leaderboard__tee-times-group-icon-time">{formatedTeeTime}
                {tenStart && <span>&nbsp;*</span>}
            </div>
        </div>
    );
};

export default LeaderboardTeeTimesGroup;
